import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $SharingCurrentTraffic } from 'shared/atoms';
import { usePOICoverImage, usePOIDescription, usePOILinkPreviewTitle } from '@poi/shared/use-poi-tdk';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';
import { useOGImageUrl } from '~/utils/libra/og-image-opt';
import { $CurrentPOIInfoAsAvailable } from '../shared/current-poi-info';

export const POIOG: FC = () => {
  const { canonicalUrl } = useAtomValue($SharingCurrentTraffic);
  const title = usePOILinkPreviewTitle();
  const description = usePOIDescription();
  const cover = usePOICoverImage();
  const poi = useAtomValue($CurrentPOIInfoAsAvailable);
  const imageMeta = useOGImageUrl({
    url: cover?.url || '',
    width: cover?.width,
    height: cover?.height,
    text: cover?.url ? undefined : poi.formattedAddress || '',
  });

  return (
    <DynamicHead>
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {Boolean(imageMeta.url) && (
        <>
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image" content={imageMeta.url} />
          {typeof imageMeta.width === 'number' && <meta property="og:image:width" content={`${imageMeta.width}`} />}
          {typeof imageMeta.height === 'number' && <meta property="og:image:height" content={`${imageMeta.height}`} />}
        </>
      )}
    </DynamicHead>
  );
};
